import React from 'react';
import Adult1 from '../../../../../images/bookingDetailAvatars/adult_1.svg';
import Adult2 from '../../../../../images/bookingDetailAvatars/adult_2.svg';
import Adult3 from '../../../../../images/bookingDetailAvatars/adult_3.svg';
import Adult4 from '../../../../../images/bookingDetailAvatars/adult_4.svg';
// import Adult1 from '../../../../../images/bookingDetailAvatars/adult_5.svg';
// import Adult2 from '../../../../../images/bookingDetailAvatars/adult_6.svg';

const AdultAvatar = () => {
    const avatars = [Adult1, Adult2, Adult3, Adult4];
    const randomIndex = Math.floor(Math.random() * avatars.length);
    const selectedAvatar = avatars[randomIndex];

    return (
        <img
            src={selectedAvatar}
            className='booking-guest__avatar'
            alt='avatar adult guest'
        />
    );
};

export default AdultAvatar;
